import React from 'react';
import { motion } from 'framer-motion';
import { SunMoon } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-24 px-6 md:px-12 bg-sage text-white" data-id="element-102">
      <div className="max-w-4xl mx-auto text-center" data-id="element-103">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-104">
          <div className="flex justify-center mb-6" data-id="element-105">
            <SunMoon size={64} className="text-cream opacity-90" data-id="element-106" />
          </div>
          <h2 className="text-3xl md:text-5xl font-bold mb-8 text-cream" data-id="element-107">
            Sincronización Circadiana 40+
          </h2>
          <div className="space-y-6 text-lg md:text-xl leading-relaxed text-cream/90 font-medium" data-id="element-108">
            <p data-id="element-109">
              Este no es un plan de calorías, es un plan de horarios y señales
              hormonales.
            </p>
            <p data-id="element-110">
              Aprenderás a usar la comida como una herramienta para enviarle un
              mensaje de "seguridad" a tu cerebro.
            </p>
            <p className="text-2xl font-bold text-white mt-8" data-id="element-111">
              Cuando tus hormonas se alinean con tu reloj biológico, el cuerpo
              suelta la grasa por sí solo porque ya no necesita protegerse del
              estrés.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}